export const faqs = [
  {
    type: 'About Bambee',
    qnas: [
      {
        question: 'What is Bambee?',
        answer: `<p>Bambee is the first outsourced human resource compliance solution for small business. We’re your full-service outsourced HR team. Bambee can help your business with employee conflict resolutions and terminations, federal and state HR compliance, and general HR policy and assistance.</p>`,
        homepage: true,
      },
      {
        question: 'How does Bambee work?',
        answer: `<span><p>Bambee believes every business owner should have access to real human resources support infrastructure at a price that’s less than a business license. Here’s how our service works:</p><ul><li><span><strong>Join Bambee and tell us a little about your business. We'll help you figure out what needs updating to make sure you're current with state and federal regulations.</strong></span></li><li><span><strong>Meet with your Bambee advisor. Once our team of HR experts identifies any problem points, we’ll give your business the Bambee Prescription. You’ll get a call from one of our HR experts, who will review your information and create a customized plan for bringing your business up to speed. We’ll solve your pressing issues first, then take measures to ensure greater protection against any potential risks.</strong></span></li><li><span><strong>Get the Bambee solution. </strong>Our team will guide you every step of the way, and answer every question to make sure you’re covered. If you need to terminate an employee, we’ll talk you through the risks of doing so and help you do so safely. And once you join Bambee, we’ll be available for any future HR needs as long as you’re a member.</span></li><li><span>Bring any concerns or issues to us. You’ll never need to worry about HR issues again.</span></li></ul></span>`,
        homepage: true,
      },
      {
        question: 'Can Bambee help me terminate employees?',
        answer: `<p>Yes. Bambee will navigate all high risk HR and termination situations for your business and coach you throughout the entire process. We’ll also make sure you have all the necessary documents and conform with HR policies going forward, to help prevent mistakes that result in expensive lawsuits.</p>`,
        homepage: true,
      },
      {
        question: 'How much does Bambee cost?',
        answer: `<p>A full time human resources department can cost over $7000 per month, and even outside consultants can set your business back by over $5000 per month. Bambee is month to month membership starting at $99 per month that you can cancel anytime.</p>`,
        homepage: true,
      },
      {
        question: 'Can Bambee help my business comply with labor laws?',
        answer:
          '<p>Yes. We’ll make Department of Labor regulations easy to understand, and ensure your ' +
          'business is compliant on both the federal and state level. Come to us with your concerns about ' +
          'things like wage and hour, benefits, overtime exemptions, and more. We’re here to answer all ' +
          'your questions by phone, email, or chat.</p>',
      },
      {
        question:
          'Will Bambee help my business with its internal HR processes?',
        answer: `<p>Yes. Our HR experts will help you create compliant policies, procedures, and documents customized for your company - onboarding packages, performance management, and much more.</p>`,
        homepage: true,
      },
      {
        question:
          'Can Bambee help me with existing government claims? business with its internal HR processes?',
        answer:
          '<p>Yes. Your Bambee advisor will help manage any government agency claims - unemployment claims, ' +
          'disability, wage and hour, EEOC, and more. We’ll also help you develop and maintain a system for ' +
          'managing all your internal corrective action and employee issues, so you’ll never go into a ' +
          'termination unprepared again.</p>',
      },
      {
        question: 'Is Bambee right for my business?',
        answer:
          '<p>Fortune 500 companies enjoy the benefit of expensive compliance teams and infrastructure ' +
          'that enables them to run their business - not their human resources processes. Bambee supports ' +
          '<strong>businesses of all sizes in every industry </strong>with their HR compliance and termination ' +
          'needs, and with plans starting at $99/mo, full-service HR can be a reality for your business. Do you ' +
          'have full-time, part-time, or contracted employees? If so, you need an HR team to protect your ' +
          'business. Let Bambee be your remote human resource team, so you can get back to work.</p>',
      },
      {
        question: "What are Bambee's Hours of Operation?",
        answer:
          '<span><p>You can reach Bambee HR Representatives:</p>' +
          '<br>' +
          '<p>Monday - Friday from 9:00 am - 6:00 pm PST</p></span>',
      },
    ],
  },
  {
    type: 'About Internal HR Strategy',
    qnas: [
      {
        question: 'Do I need to provide an offer letter to new hires?',
        answer:
          '<p>Though not required by law, an offer letter can help to add clarity to employer/employee ' +
          'agreements and act as additional defense for your business in court should conflicts arise. Offer ' +
          'letters can also help to set guidelines and expectations and confirm agreements between an ' +
          'employer and employee around job title, salary, and performance goals. <strong>Proof of this agreement ' +
          'is an important protection for you and your business.</strong> Bambee will write a customized offer ' +
          'letter on your behalf and help you establish an HR process, so you can avoid mistakes that ' +
          'make your business vulnerable to legal retribution.</p>',
      },
      {
        question: 'Should I be running background checks?',
        answer:
          '<p>Yes. Although most small businesses don’t run background checks on prospective hires, ' +
          'it’s an important precautionary measure that can protect your business, your clients, and the ' +
          'rest of your employees. Contact us at Bambee for help with this and all your HR questions.</p>',
      },
      {
        question:
          'How should I categorize exemption status for cross-functional employees?',
        answer:
          '<p>Appropriate exempt/non-exempt classification for employees is important, as it determines ' +
          'whether or not they are eligible for overtime pay in accordance with the Fair Labor Standards Act. ' +
          'Classification is decided by an employee’s ‘primary duties,’ which can vary widely in a small business ' +
          'that requires employees to work on many different tasks at once. Contact us here at Bambee and we’ll ' +
          'help to ensure your business avoids an FLSA violation.</p>',
      },
      {
        question: 'How many hours per week should my employees be working?',
        answer:
          '<p>The Department of Labor does not mandate a set number of working hours for employees over age ' +
          '16. Contact us to help you set some guidelines for your team.</p>',
      },
      {
        question: 'Can I terminate someone with a disability?',
        answer: `<span><p>Under the Americans with Disabilities Act (ADA), employers can fire workers with disabilities under three conditions:</p>
            <ul>
            <li>
            <span>The termination is unrelated to the disability or</span>
            </li>
            <li>
            <span>The employee does not meet legitimate requirements for the job, such as performance or production standards, with or without a reasonable accommodation or</span>
            </li>
            <li>
            <span>Because of the employee's disability, he or she poses a direct threat to health or safety in the workplace.</span>
            </li>
            </ul></span>`,
        homepage: true,
      },
      {
        question: 'Am I required to provide Paid Time Off and Paid Sick Leave?',
        answer: `<ul>
              <li><span>The Fair Labor Standards Act (FLSA) does not require payment for time not worked, such as vacations, sick leave or federal or other holidays. These benefits are matters of agreement between an employer and an employee (or the employee's representative). However, some states require employers to provide Paid Sick Leave. </span></li>
              <li><span>There are currently thirteen states, and Washington D.C., that have paid sick leave laws at the state level:</span>
                <ul>
                  <li><span>Connecticut</span></li>
                  <li><span>California</span></li>
                  <li><span>Massachusetts</span></li>
                  <li><span>Oregon</span></li>
                  <li><span>Vermont</span></li>
                  <li><span>Arizona</span></li>
                  <li><span>Washington</span></li>
                  <li><span>Washington, D.C.</span></li>
                  <li><span>Maryland</span></li>
                  <li><span>Michigan</span></li>
                  <li><span>Nevada</span></li>
                  <li><span>New Jersey</span></li>
                  <li><span>Rhode Island</span></li>
                </ul>
              </li>
            </ul>`,
        homepage: true,
      },
      {
        question: 'When must breaks and meal periods be given?',
        answer:
          '<p>Regulations for the number of breaks that must be offered differ by state. Contact us here ' +
          'at Bambee, and we’ll help you figure out what your team’s schedule should look like.</p>',
      },
      {
        question:
          'Can I have an employee perform duties outside their job description?',
        answer:
          '<p>The Department of Labor does not set regulations on this - but it’s a gray area that could ' +
          'cost you in a termination claim. Contact us so we can discuss the specifics of your situation.</p>',
      },
      {
        question:
          'If an employee gives two-weeks’ notice but I ask them to leave immediately, am I required to pay them the full two weeks?',
        answer:
          '<p>Requiring early leave when an employee gives their two-week notice could qualify as an ' +
          'involuntary termination, which would give your former employee the right to collect unemployment ' +
          'benefits. The answer to this question depends completely on circumstances - if you’re in this situation, ' +
          'it would be in your best interest to contact us immediately.</p>',
      },
      {
        question: 'What constitutes insubordination in the workplace?',
        answer:
          '<p>An employee can be considered insubordinate if they either disrespect, harass, or wilfully ' +
          'disobey an order from a superior.</p>',
      },
    ],
  },
  {
    type: 'About Labor & Compliance',
    qnas: [
      {
        question: 'What is an I-9 form?',
        answer:
          '<p>An I-9 form verifies employment authorization for anyone hired in the United States. ' +
          'Federal law requires a completed I-9 form to be on file for all employees, and available for ' +
          'inspection at anytime.</p>',
      },
      {
        question:
          'A former employee just returned from active duty to resume employment, but they’re out of ' +
          'practice and not up to date with our company’s changes. Can I deny them employment?',
        answer:
          '<p>Service members have special workplace rights in accordance with the Department of Labor, ' +
          'and failing to comply with them can cost you. Bambee will make sure your company is following all ' +
          'veteran regulations, so you can stay protected from risk.</p>',
      },
      {
        question:
          'What regulations am I required to follow in accordance with OSHA?',
        answer:
          '<p>The Occupational Safety and Health Administration (OSHA) mandates workplace health and ' +
          'safety regulations to keep businesses free of health threats. OSHA has unique guidelines for each ' +
          'industry and its specific safety risks. For specific questions on what your business needs to comply ' +
          'with OSHA, contact us.</p>',
      },
      {
        question:
          'My employees receive tips for their work. What is the minimum wage I must pay them?',
        answer:
          '<p>The federal minimum wage for nonexempt employees is $7.25 per hour, but employers of ' +
          'employees who receive tips are only required to pay $2.13 an hour in direct wages if that amount plus ' +
          'the workers tips equals at least $7.25 per hour in total - and that employee usually makes over $30 ' +
          'per month in tips. Some tipping laws can differ by state. Contact Bambee if you’re unsure how much ' +
          'you should be paying employees.</p>',
      },
      {
        question: 'Are my workers eligible for overtime payment?',
        answer:
          '<p>The Department of Labor requires overtime pay for covered, nonexempt employees at a rate of ' +
          'one and one half times their regular rate after working 40 hours in a week. the Fair Labor Standards Act ' +
          "(FLSA) requires overtime pay at a rate of not less than one and one-half times an employee's regular rate " +
          'of pay after 40 hours of work in a workweek.</p>',
      },
      {
        question:
          'Should my employees be paid for sending email off the clock?',
        answer:
          '<p>Whether employees should be compensated after hours work depends on their exemption status. ' +
          'Non-exempt employees must be paid time-and-one-half for all work done after hours, including ' +
          'communications related to work. Failure to properly classify or compensate employees can result in ' +
          'employers being forced to provide up to 3 years of back-pay for employees seeking recovered wages. ' +
          'Additionally, businesses accused of being in violation are often audited completely. These audits ' +
          'often lead to expensive class action suits, which could mean a loss of hundreds of thousands for your ' +
          'business if you’re found to be in violation.</p>',
      },
      {
        question:
          'I was planning on firing an employee for poor performance, and then they notified me they ' +
          'will be taking parental leave. Can I still fire them?',
        answer:
          '<p>If the employee can prove that the grounds for their termination are in violation of the ' +
          'Family and Medical Leave Act (FMLA), you could be at risk. Violation of the FMLA can result in a personal ' +
          'or federal lawsuit brought to force compliance, and fines for non-compliance. Contact Bambee before ' +
          'taking action.</p>',
      },
      {
        question:
          'What are the consequences for failure to comply with Equal Employment Opportunity (EEO)?',
        answer:
          '<p>Equal employment opportunity regulations prohibit workplace discrimination. Violations of EEO ' +
          'can result in hefty fines, lengthy and expensive lawsuits, and even a potential loss of business. If you ' +
          'think an employee has made or will make a wrongful discrimination claim after ending employment with your ' +
          'organization, contact us immediately for assistance in avoiding an expensive lawsuit that could result ' +
          'in the loss of your business.</p>',
      },
      {
        question:
          'Can I be sued for firing an employee and replacing them with a family member?',
        answer:
          '<p>Though workplace nepotism is not technically illegal, your circumstances around replacing an ' +
          'employee with a friend or family member could put you at risk of a lawsuit.Contact Bambee before ' +
          'taking action.</p>',
      },
    ],
  },
  {
    type: 'About Termination & Employee Types',
    qnas: [
      {
        question: 'What qualifies as job abandonment?',
        answer:
          '<p>Technically considered voluntary resignation, job abandonment occurs when an employee does ' +
          'not show up for scheduled working hours for a number of consecutive days. In most states, 3 consecutive ' +
          'days of unexcused absences is considered job abandonment. If a former employee has abandoned their role ' +
          'at your business, contact us immediately to ensure your business is protected against any potential ' +
          'retribution.</p>',
      },
      {
        question: 'Am I at risk of wrongful termination?',
        answer:
          '<span><p>You may be at risk if: </p>' +
          '<ul>' +
          '<li><span>Your reasons for terminating are prohibited by law, such as a discrimination based termination</span></li>' +
          "<li><span>Your reasons for terminating violated an employee's rights, for example, terminating an employee for reporting a workplace violation</span></li>" +
          '<li><span>You terminated an employee on leave in accordance with the Family and Medical Leave Act.</span></li>' +
          '</ul>' +
          "<p style='margin-top: 10px;'>In some cases, employees bring wrongful termination suits without cause - but unfortunately, your " +
          'business might still be at risk. If you think an employee has made or will make a wrongful termination ' +
          'claim against you or your business, contact us immediately for assistance in avoiding an expensive ' +
          'lawsuit that could result in the loss of your business.</p></span>',
      },
      {
        question: 'If I terminate an employee, do I have to pay unemployment?',
        answer: `<p>Fired employees can claim unemployment benefits if they were terminated because of financial cutbacks or because they were not a good fit for the job for which they were hired. On the other hand, in most states, an employee who is fired for misconduct will not receive unemployment benefits. Employers are able to contest unemployment claims by responding to the claim notice immediately and sending in supporting documents. It is important to consistently track all employee incidences, warnings, write-ups and coaching.  With Bambee's Corrective Action tracking system, all of these items will be stored under each employee's profile and available to print to help you in contesting unemployment claims. </p>`,
        homepage: true,
      },
      {
        question: 'When can I classify an employee as seasonal?',
        answer:
          '<p>An employee is generally considered seasonal if their set period of employment is less than ' +
          'six months. Improper classification of seasonal employees can result in expensive lawsuits. </p>',
      },
      {
        question: 'What gives an employee exempt status?',
        answer:
          '<p>To qualify as exempt, as an employee must be paid a set salary of at least $455/week, ' +
          'be performing executive, professional, or administrative duties, or be designated as computer ' +
          'professionals or outside sales associates, and not be performing non-exempt duties for more than ' +
          'half their working hours. Failure to comply with classify exempt employees correctly can result ' +
          'in employers being forced to provide up to 3 years of back-pay for employees seeking recovered wages. ' +
          'Bambee can help make sure your employees are classified correctly, and help you avoid risk.</p>',
      },
      {
        question: 'What gives an employee non-exempt status?',
        answer:
          '<p>Workers are typically classified as non-exempt if they are blue-collar or semi-skilled non-managers. </p>',
      },
      {
        question: 'What is at-will employment?',
        answer:
          '<p>At-will employment describes the agreement between employer and employee that states either ' +
          'party can end employment at any time for any reason. Dismissals classified as wrongful termination are ' +
          'the exception to legalities of at-will employment termination. If you are unsure as to whether your ' +
          'business is covered by at-will laws, contact us here at Bambee to create a compliant termination plan ' +
          'customized for your business.</p>',
      },
      {
        question: 'How much time do I have to pay a terminated employee?',
        answer:
          '<p>The amount of time you have to pay a terminated employee the remainder of their wages ' +
          'depends on whether their termination is classified as voluntary or involuntary. Bambee can help you ' +
          'make this determination, and create a compliant termination plan that ensures your business is protected.</p>',
      },
    ],
  },
  {
    type: 'About Claims Management',
    qnas: [
      {
        question:
          'What are the consequences for the improper classification of employees?',
        answer:
          '<p>Failure to comply with the FLSA can result in employers being forced to provide up to 3 years ' +
          'of back-pay for employees seeking recovered wages. Additionally, businesses accused of being in violation ' +
          'are often audited completely. These audits often lead to expensive class action suits, which could mean ' +
          'a loss of hundreds of thousands for your business if you’re found to be in violation.</p>',
      },
      {
        question:
          'I fired an employee whose wages were being garnished. Will I be sued?',
        answer:
          '<p>Employers found guilty of discharging an employee because of their wage garnishment situation ' +
          'may have to reinstate their employment, and pay wages lost during unemployment. If the violation is ' +
          'determined to be willful, the employer may be fined up to $1000, imprisoned for a year, or both.</p>',
      },
      {
        question: 'What does OSHA classify as a ‘serious violation?’',
        answer:
          '<p>OSHA violations that are obvious and have a high likelihood of resulting in injury or ' +
          'death are categorized as serious violations. Consequences for serious violations include a maximum ' +
          'fine of $7,000, dependent on how dangerous the violation and how quickly the business complies upon ' +
          'notification.</p>',
      },
      {
        question:
          'What are the consequences for failing to comply with an OSHA warning?',
        answer:
          '<p>Failure to Abate Prior Violation | Failure to resolve a violation noted in a previous ' +
          'inspection by the given deadline falls under the category of repeated violations, and can cost a ' +
          'business up to $70,000.</p>',
      },
      {
        question:
          'Under what circumstances might an employee file an EEOC claim?',
        answer:
          '<p>If an employee can provide evidence that your business has discriminated against them ' +
          'because of their race, sex, age, religion, or disability, they might be able to make an EEOC case ' +
          'against your business. Employees who report a violation of EEO may be granted the right to sue the ' +
          'offending organization by the Equal Opportunity Employment ' +
          'Commission. If you think an employee has made or will make a wrongful discrimination claim after ' +
          'ending employment with your organization, contact us immediately for assistance in avoiding an ' +
          'expensive lawsuit that could result in the loss of your business.</p>',
      },
    ],
  },
  {
    type: false,
    qnas: [
      {
        question: 'Can Bambee help me navigate a workers compensation claim?',
        answer: `<p>Yes! Bambee can guide you through the steps on processing a claim with your Worker's Compensation Insurance company. We can also coach you on how to protect your business from potential law suits through proper documentation.  Bambee HR advisors are there to advise you through every step of the worker's compensation claim process.</p>`,
        homepage: true,
      },
      {
        question:
          'What should I do if there is a State, City, Federal minimum wage conflict?',
        answer: `<p>The minimum wage in the United States is set by US labor law and a network of state, and local laws. Employers generally must pay workers the highest minimum wage prescribed by federal, state, and local law. </p>`,
        homepage: true,
      },
      {
        question: 'How do I keep up with regulation changes in the government?',
        answer: `<p>Bambee HR advisors stay on top of regulation changes that may impact your business. By subscribing to our services, you will be able to regularly access up-to-date information about upcoming legislation changes and how they may your business.</p>`,
        homepage: true,
      },
      {
        question:
          'How should I respond if I receive a claim from the department of labor?',
        answer: `<p>If you receive a Department of Labor claim, please contact your dedicated HR Manager immediately. We will advise you on next steps.</p>`,
        homepage: true,
      },
      {
        question: 'What is Wage and Hour law?',
        answer: `<p>Wage and hour law refers to the body of law that establishes and regulates wage standards, including, but not limited to, minimum wage and overtime. The Fair Labor Standards Act (FLSA) sets the majority of wage and hour law at the federal level. Other factors, however, control minimum wage as well. The IRS, for example, sets the parameters for when an individual working for tips can work for less than the federal standard minimum wage. Many states and some cities have wage and hour laws as well. These laws govern issues such as minimum wage, overtime, and meal breaks. The governing bodies in several urban areas throughout the country have voted to create a “living wage” on top of the FLSA and state standards.</p>`,
        homepage: true,
      },
      {
        question: 'What is the EEOC?',
        answer: `<span><p>The U.S. Equal Employment Opportunity Commission (EEOC) is responsible for enforcing federal laws that make it illegal to discriminate against a job applicant or an employee because of the person's race, color, religion, sex (including pregnancy, gender identity, and sexual orientation), national origin, age (40 or older), disability or genetic information. It is also illegal to discriminate against a person because the person complained about discrimination, filed a charge of discrimination, or participated in an employment discrimination investigation or lawsuit.</p>
              <ul><li><span>Most employers with at least 15 employees are covered by EEOC laws (20 employees in age discrimination cases). Most labor unions and employment agencies are also covered.
              </span></li><li><span>The laws apply to all types of work situations, including hiring, firing, promotions, harassment, training, wages, and benefits.</span></li></ul></span>`,
        homepage: true,
      },
    ],
  },
];

export default faqs;
